// /var/www/afra/web-design.rampagesoft.com/my-app/src/services/api.js

const API_BASE_URL = 'https://py.afaa.website/api';

const fetchWithRetry = async (url, options, retries = 3, delay = 500) => {
  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      if (i < retries - 1) {
        await new Promise(resolve => setTimeout(resolve, delay));
        continue;
      }
      throw error;
    }
  }
};

export const fetchPosts = async (limit = 10, offset = 0) => {
  try {
    const data = await fetchWithRetry(`${API_BASE_URL}/content/view?limit=${limit}&offset=${offset}`, {
      mode: 'cors',
    });
    return data;
  } catch (error) {
    throw new Error(`Failed to fetch posts: ${error.message}`);
  }
};

export const fetchPostById = async (homeId) => {
  try {
    let data = await fetchWithRetry(`${API_BASE_URL}/content/view?Home_ID=${homeId}`, {
      mode: 'cors',
    });
    //console.log(`[API] fetchPostById(${homeId}) initial response:`, data);

    if (!data.results?.length || !data.results.find(p => p.Home_ID === parseInt(homeId, 10))) {
      //console.warn(`[API] Post ID ${homeId} not found in initial response. Starting pagination.`);
      let offset = 0;
      const limit = 10;
      while (offset < (data.total_count || 0)) {
        data = await fetchPosts(limit, offset);
        //console.log(`[API] Pagination fetch for ID ${homeId}, offset ${offset}:`, data);
        if (data.results?.find(p => p.Home_ID === parseInt(homeId, 10))) {
          break;
        }
        offset += limit;
      }
    }

    const post = data.results?.find(p => p.Home_ID === parseInt(homeId, 10));
    return {
      results: post ? [post] : [],
      total_count: data.total_count || 0,
      limit: data.limit || 10,
      offset: data.offset || 0,
    };
  } catch (error) {
    console.error(`[API] Failed to fetch post with Home_ID ${homeId}:`, error.message);
    throw new Error(`Failed to fetch post with Home_ID ${homeId}: ${error.message}`);
  }
};

export const fetchPostImage = async (homeId) => {
  try {
    const data = await fetchWithRetry(`${API_BASE_URL}/content_image/view?Home_ID=${homeId}`, {
      mode: 'cors',
    });
    return data;
  } catch (error) {
    throw new Error(`Failed to fetch image for Home_ID ${homeId}: ${error.message}`);
  }
};

export const incrementVisitors = async (homeId) => {
  try {
    const data = await fetchWithRetry(`${API_BASE_URL}/content/visit`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify([{ Home_ID: homeId }]),
      mode: 'cors',
    });
    return data;
  } catch (error) {
    throw new Error(`Failed to increment visitors for Home_ID ${homeId}: ${error.message}`);
  }
};